import * as React from 'react';
import { createSvgIcon } from '@mui/material/utils';
/**
 * @ignore - internal component.
 */

import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');